export class RoleTypes {
  // Normalized names of roles
  public static orgSearchProduct = 'PR_SAASSEARCHORDER';
  public static orgSearch = 'PR_SAASSEARCHORDER_FR_ORGSEARCH';
  public static tasking = 'PR_TASKING';
  public static practiceUser = 'PRACTICEUSER';
  public static saasAdmin = 'PR_SAAS_FR_SAASADMIN';
  public static insolsaasAdmin = 'insolsaasadmin';
  public static licenseAdministrator = 'LicenseAdministrator';
  public static bankfeedAdministrator = 'BankfeedAdministrator';
  public static aryzaProductOnboarding = 'AryzaProductOnboarding';
  /** Practice can specify multiple recovery periods per job (instead of just a Low Recovery start date) */
  public static multiRecoveryPeriods = 'PR_MULTIPLERECOVERY';

  public static timekeepingAdmin = 'PR_TIMEKEEPING_FR_TIMEKEEPINGADMINISTRATOR';
  public static timekeepingMigration = 'PR_TIMEKEEPING_FR_TIMEKEEPINGMIGRATION';
  public static timekeepingUser = 'PR_TIMEKEEPING_FR_TIMEKEEPINGUSER';
  public static provisionsAdmin = 'PR_TIMEKEEPING_FR_PROVISIONADMINISTRATOR';

  public static timekeepingAdvancedReport = 'PR_ADVANCEDREPORTS';

  // There are others; add as needed
}
